import { api } from "~/api";
import { BookingFlow } from "../booking-flows/types";
import {
  AuthenticatedScreeningPayload,
  NewPatientScreeningPayload,
  ScreeningApiPayload,
} from "./types";

export const saveScreeningResponses = async (
  bookingFlowId: BookingFlow["id"],
  data: ScreeningApiPayload,
) => {
  const payload = {
    ...data,
    state: data.state instanceof Object ? data.state.id : data.state,
    insurance:
      data.insurance instanceof Object ? data.insurance.id : data.insurance,
  };
  const response = await api.post(
    `/booking-flows/${bookingFlowId}/screenings`,
    payload,
  );
  return response.data;
};

export const saveUserScreeningResponses = async (
  bookingFlowId: BookingFlow["id"],
  data: NewPatientScreeningPayload | AuthenticatedScreeningPayload,
) => {
  const { email, ...rest } = data;

  const payload = {
    ...rest,
    state: data.state instanceof Object ? data.state.id : data.state,
    insurance:
      data.insurance instanceof Object ? data.insurance.id : data.insurance,
  };
  const response = await api.post(
    `/booking-flows/${bookingFlowId}/screenings/user`,
    payload,
  );
  return response.data;
};
